import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CustomDialog, CustomIconButton, CustomTooltip, icon } from "../../../../common/components";
import styles from "./ChatRow.module.css";
import { useApi } from "../../../../common/hooks";
import { AiChatService } from "../../../../api";
import ChatNameEditDialog from "../../../../common/components/dialogs/chat-name-dialog/ChatNameEditDialog";
import { translate } from "../../../../common/providers";

const ChatRow = ({
	loading = false,
	onChangeSelectedChat,
	onSetToRefresh,
	row,
	selected = false,
	"data-testid": dataTestId,
}) => {
	const [hovered, setHovered] = useState(false);
	const projectId = useSelector(({ context }) => context.project?.id);
	const { call: deleteChat } = useApi(AiChatService.deleteChat);
	const { call: editChatName } = useApi(AiChatService.editChatName);
	const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
	const [openEditDialog, setOpenEditDialog] = useState(false);
	const [displayName, setDisplayName] = useState("");
	useEffect(() => {
		setDisplayName(row?.name);
	}, [row]);
	const handleMouseEnter = () => {
		setHovered(true);
	};
	const handleMouseLeave = () => {
		setHovered(false);
	};
	const handleClick = () => {
		if (loading) {
			return;
		}
		onChangeSelectedChat(row.id);
	};
	const handleOpenDeleteDialog = (event) => {
		event.stopPropagation();
		setOpenDeleteDialog(true);
	};
	const handleCloseDeleteDialog = () => {
		setOpenDeleteDialog(false);
	};
	const handleDelete = () => {
		deleteChat({ projectId, chatId: row.id })
			.then(() => {
				if (selected) {
					onChangeSelectedChat(0);
				}
				onSetToRefresh(true);
			})
			.catch((err) => console.error(err))
			.finally(() => handleCloseDeleteDialog());
	};
	const handleClickEdit = (event) => {
		event.stopPropagation();
		setOpenEditDialog(true);
	};
	const handleCloseEditDialog = () => {
		setOpenEditDialog(false);
	};
	const handleEditChatNameSubmit = (newName) => {
		editChatName({ projectId, chatId: row.id }, { value: newName })
			.then(() => {
				setDisplayName(newName);
				handleCloseEditDialog();
			})
			.catch((error) => {
				console.error(error);
			});
	};

	return (
		<>
			<div
				className={styles.row__container}
				data-loading={loading}
				data-selected={selected}
				data-testid={dataTestId}
				role="presentation"
				onClick={handleClick}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
			>
				<CustomTooltip arrow showWhenOverflow disableHoverListener={loading} title={displayName}>
					<div className={styles.title__container}>{displayName}</div>
				</CustomTooltip>
				{hovered && (
					<div className={styles.btn__container}>
						<CustomIconButton
							btnClassName={styles.button}
							data-testid={`edit-button-${row.id}`}
							icon={icon.faPenToSquare}
							iconClassName={styles.iconClassName}
							size="xs"
							onClick={handleClickEdit}
						/>
						<CustomIconButton
							btnClassName={styles.button}
							data-testid={`delete-button-${row.id}`}
							icon={icon.faTrash}
							iconClassName={styles.iconClassName}
							size="xs"
							onClick={handleOpenDeleteDialog}
						/>
					</div>
				)}
			</div>
			<CustomDialog
				iconColor="var(--red-500)"
				iconModel={icon.faExclamationTriangle}
				open={openDeleteDialog}
				title={translate("common:delete-confirmation-popup.title")}
				onClose={handleCloseDeleteDialog}
				onSubmit={handleDelete}
			/>
			<ChatNameEditDialog
				initialName={displayName}
				open={openEditDialog}
				onClose={handleCloseEditDialog}
				onSave={handleEditChatNameSubmit}
			/>
		</>
	);
};

export default ChatRow;
